var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.valueFormat") } },
    [
      _c(
        "el-select",
        {
          attrs: { filterable: "", "allow-create": "" },
          model: {
            value: _vm.optionModel.valueFormat,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "valueFormat", $$v)
            },
            expression: "optionModel.valueFormat",
          },
        },
        [
          _c("el-option", {
            attrs: { label: "yyyy-MM-dd", value: "yyyy-MM-dd" },
          }),
          _vm._v(" "),
          _c("el-option", {
            attrs: {
              label: "yyyy-MM-dd HH:mm:ss",
              value: "yyyy-MM-dd HH:mm:ss",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }